import { IDataProvider } from "../interfaces";
import { Field } from "./Field/Field";

export class RecordUi {
    private _getField: (columnName: string) => Field;
    private _dataProvider: IDataProvider;

    constructor(dataProvider: IDataProvider, getField: (columnName: string) => Field) {
        this._dataProvider = dataProvider;
        this._getField = getField;
    }
    public getNotifications(columnName: string) {
        return this._getField(columnName).getNotifications();
    }

    public isLoading(columnName: string) {
        return this._getField(columnName).isLoading();
    }

    public getHeight(columnWidths: { [name: string]: number }, defaultRowHeight: number) {
        const cellHeights = this._dataProvider.getColumns().map(col => this._getField(col.name).getHeight(columnWidths[col.name], defaultRowHeight)).filter(x => x !== undefined);
        if (cellHeights.length === 0) {
            return defaultRowHeight;
        }
        return Math.max(...cellHeights as number[]);
    }

    public getCellEditorParameters(columnName: string, currentParameters: any) {
        return this._getField(columnName).getCellEditorParameters(currentParameters) ?? currentParameters;
    }

}